import { IconSVGProps } from '@clover-web-lib-sprout/common';
import React from 'react';

export const Info: React.FC<IconSVGProps> = ({ ...props }) => (
  <svg
    {...props}
    role={props.role}
    focusable={false}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7490_6144)">
      <path
        d="M11.8 13.6H11.2C10.8818 13.6 10.5765 13.4736 10.3514 13.2486C10.1264 13.0235 10 12.7182 10 12.4V9.4C10 9.24088 9.9368 9.08824 9.82424 8.97576C9.71176 8.8632 9.55912 8.8 9.4 8.8H8.8M9.7 6.4H9.75M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7490_6144">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CheckCircle: React.FC<IconSVGProps> = ({ ...props }) => (
  <svg
    {...props}
    role={props.role}
    focusable={false}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7490_6141)">
      <path
        d="M5.2 10.9792L7.16 13.7608C7.23435 13.8719 7.33414 13.9635 7.45108 14.0282C7.56801 14.0929 7.69871 14.1288 7.8323 14.1328C7.96588 14.1368 8.09848 14.1088 8.21907 14.0512C8.33967 13.9936 8.44476 13.908 8.5256 13.8016L14.8 5.8632M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7490_6141">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ColoredWarning: React.FC<IconSVGProps> = ({ ...props }) => (
  <svg
    {...props}
    role={props.role}
    focusable={false}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 14.7997V9.39966M12 17.4H12.1M13.0504 4.61978C12.9467 4.43202 12.7945 4.2755 12.6098 4.1665C12.4251 4.05749 12.2145 4 12 4C11.7854 4 11.5749 4.05749 11.3902 4.1665C11.2054 4.2755 11.0533 4.43202 10.9496 4.61978L3.14948 19.0199C3.04861 19.2027 2.99713 19.4085 3.00012 19.6172C3.00311 19.8258 3.06047 20.0301 3.16653 20.2098C3.27259 20.3896 3.42368 20.5385 3.60491 20.642C3.78613 20.7455 3.9912 20.8 4.19989 20.8H19.8001C20.0087 20.8 20.2139 20.7455 20.3951 20.642C20.5763 20.5385 20.7274 20.3896 20.8335 20.2098C20.9395 20.0301 20.9968 19.8258 20.9999 19.6172C21.0028 19.4085 20.9513 19.2027 20.8505 19.0199L13.0504 4.61978Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ErrorIcon: React.FC<IconSVGProps> = ({ ...props }) => (
  <svg
    {...props}
    role={props.role}
    focusable={false}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1551_111)">
      <path
        d="M10 11.4V5.4M10 14.5V14.4M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z"
        stroke="#C60000"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1551_111">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const UpsellStar: React.FC<IconSVGProps> = ({ ...props }) => (
  <svg
    {...props}
    role={props.role}
    focusable={false}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1939 13.7475C11.3375 13.1256 11.6529 12.5566 12.1041 12.1052C12.5554 11.6538 13.1244 11.3382 13.7463 11.1944L18.8689 10.0124C18.9629 9.99103 19.0469 9.93835 19.1071 9.86299C19.1672 9.78763 19.2 9.69407 19.2 9.59765C19.2 9.50123 19.1672 9.40767 19.1071 9.33231C19.0469 9.25695 18.9629 9.20427 18.8689 9.1829L13.7463 8.00211C13.1246 7.85835 12.5557 7.54293 12.1044 7.09176C11.6532 6.6406 11.3377 6.07182 11.1939 5.45019L10.0117 0.33107C9.99029 0.237045 9.9376 0.15307 9.86223 0.0929166C9.78685 0.0327627 9.69327 0 9.59683 0C9.50039 0 9.40681 0.0327627 9.33143 0.0929166C9.25606 0.15307 9.20337 0.237045 9.182 0.33107L8.00096 5.45019C7.85716 6.07182 7.54168 6.6406 7.09042 7.09176C6.63917 7.54293 6.07027 7.85835 5.44851 8.00211L0.327146 9.1829C0.233941 9.20524 0.150976 9.25831 0.0916258 9.33355C0.0322758 9.40879 0 9.50182 0 9.59765C0 9.69347 0.0322758 9.7865 0.0916258 9.86175C0.150976 9.93699 0.233941 9.99006 0.327146 10.0124L5.44733 11.1944C6.06924 11.3382 6.63824 11.6538 7.08951 12.1052C7.54078 12.5566 7.85618 13.1256 7.99978 13.7475L9.182 18.8689C9.20337 18.963 9.25606 19.0469 9.33143 19.1071C9.40681 19.1672 9.50039 19.2 9.59683 19.2C9.69327 19.2 9.78685 19.1672 9.86223 19.1071C9.9376 19.0469 9.99029 18.963 10.0117 18.8689L11.1939 13.7475Z"
      fill="#14818D"
    />
    <path
      d="M19.364 19.3609L22.5917 18.2844C22.6523 18.2645 22.7051 18.226 22.7425 18.1743C22.7799 18.1226 22.8 18.0604 22.8 17.9966C22.8 17.9328 22.7799 17.8707 22.7425 17.819C22.7051 17.7673 22.6523 17.7288 22.5917 17.7088L19.9414 16.8246C19.763 16.7648 19.6009 16.6644 19.4679 16.5313C19.3348 16.3983 19.2345 16.2362 19.1747 16.0577L18.2897 13.4069C18.2695 13.3466 18.2309 13.2942 18.1794 13.2571C18.1278 13.2199 18.0659 13.2 18.0024 13.2C17.9388 13.2 17.8769 13.2199 17.8254 13.2571C17.7738 13.2942 17.7352 13.3466 17.7151 13.4069L16.831 16.0577C16.7715 16.2364 16.6711 16.3988 16.5378 16.5319C16.4046 16.665 16.2421 16.7652 16.0634 16.8246L13.4083 17.7098C13.3477 17.7297 13.295 17.7683 13.2576 17.8199C13.2202 17.8716 13.2 17.9338 13.2 17.9976C13.2 18.0614 13.2202 18.1236 13.2576 18.1752C13.295 18.2269 13.3477 18.2655 13.4083 18.2854L16.0634 19.1706C16.2421 19.2298 16.4045 19.33 16.5376 19.4631C16.6707 19.5963 16.7709 19.7587 16.8301 19.9374L17.7151 22.593C17.7352 22.6533 17.7738 22.7057 17.8254 22.7428C17.8769 22.78 17.9388 22.8 18.0024 22.8C18.0659 22.8 18.1278 22.78 18.1794 22.7428C18.2309 22.7057 18.2695 22.6533 18.2897 22.593L19.364 19.3609Z"
      fill="#69D0DD"
    />
  </svg>
);

export const Close: React.FC<IconSVGProps> = ({ ...props }) => (
  <svg
    {...props}
    role={props.role}
    focusable={false}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7 17L17 7M17 17L7 7" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const BANNER_ICON_MAP: Record<string, React.FC<IconSVGProps>> = {
  Info,
  CheckCircle,
  ColoredWarning,
  ErrorIcon,
  UpsellStar,
  Close,
};
